import axios from 'axios';

// eslint-disable-next-line max-len
const debug = process.env.NODE_ENV !== 'production' || (typeof window !== 'undefined' && !window.location.host.includes('centrinvest.ru'));
const suggestionsHost = debug
    ? process.env.SUGGESTIONS_SHOWROOM_API_URL || 'https://showroom13.dev.cinet.ru/'
    : 'https://www.centrinvest.ru/';
const SUGGESTIONS_BASE_URL = `
    ${suggestionsHost}cabinet/api/suggestions
`;

export const SERVICE_TYPE_DADATA_ORGANIZATION = 'dadata.organization';
export const SERVICE_TYPE_DADATA_FMS_ISSUED_NAME = 'dadata.fmsUnit';
export const SERVICE_TYPE_FIRST_NAME = 'fio.firstName';
export const SERVICE_TYPE_LAST_NAME = 'fio.lastName';
export const SERVICE_TYPE_PATRONYMIC = 'fio.patronymic';
export const SERVICE_TYPE_FIO_FULL = 'fio.fullName';
export const SERVICE_TYPE_AHUNTER_ADDRESS = 'ahunter.address';
export const SERVICE_TYPE_DADATA_ADDRESS = 'dadata.address';
export const SERVICE_TYPE_EMAIL = 'email';
export const SERVICE_TYPE_PROFESSION = 'profession';
export const SERVICE_TYPE_DADATA_BANK = 'dadata.bank';
export const SERVICE_TYPE_POSTCODE = 'postcode';
export const SERVICE_IPLOCATE = 'dadata.iplocate';
export const SERVICE_GEOLOCATE = 'dadata.geolocate';

export const SUGGESTION_TYPES = {
    SUGGESTIONS: 'suggestions',
    SUGGESTIONS_POST: 'suggestionsPost',
    SUGGESTIONS_COMPANY_NAME: 'companyNameSuggestions',
    SUGGESTIONS_FIRST_NAME: 'fioFirstNameSuggestions',
    SUGGESTIONS_LAST_NAME: 'fioLastNameSuggestions',
    SUGGESTIONS_PATRONYMIC: 'fioPatronymicSuggestions',
    SUGGESTIONS_FULLNAME: 'fioFullNameSuggestions',
    SUGGESTIONS_AHUNTER_ADDRESS: 'ahunterAddressSuggestions',
    SUGGESTIONS_DADATA_ADDRESS: 'dadataAddressSuggestions',
    SUGGESTIONS_EMAIL: 'emailSuggestions',
    SUGGESTIONS_PROFESSION: 'professionSuggestions',
    SUGGESTIONS_DADATA_BANK: 'dadataBankSuggestions',
    SUGGESTIONS_POST_CODE: 'postcodeSuggestions',
    SUGGESTIONS_PASSPORT_ISSUED_NAME: 'passportIssuedName',
};

const suggestionsApiClient = {
    async [SUGGESTION_TYPES.SUGGESTIONS](requestParams) {
        try {
            const response = await axios.get(
                SUGGESTIONS_BASE_URL,
                {
                    params: requestParams,
                    timeout: debug ? 10000 : 5000,
                });

            return response;
        } catch (e) {
            throw new Error(e);
        }
    },
    async [SUGGESTION_TYPES.SUGGESTIONS_POST](requestParams, queryParams) {
        const params = new URLSearchParams(queryParams).toString();
        try {
            const response = await axios.post(`${SUGGESTIONS_BASE_URL}?${params}`, requestParams, {
                timeout: debug ? 10000 : 5000,
            });

            return response;
        } catch (e) {
            throw new Error(e);
        }
    },
    [SUGGESTION_TYPES.SUGGESTIONS_COMPANY_NAME](params) {
        const filtered = params.query.replace(/_/g, '');
        const requestParams = {
            ...params,
            query: filtered,
            service: SERVICE_TYPE_DADATA_ORGANIZATION,
            suggestionType: params.suggestionType || '',
        };

        return this[SUGGESTION_TYPES.SUGGESTIONS](requestParams);
    },
    [SUGGESTION_TYPES.SUGGESTIONS_FIRST_NAME](params) {
        const requestParams = {
            ...params,
            service: SERVICE_TYPE_FIRST_NAME,
        };

        return this[SUGGESTION_TYPES.SUGGESTIONS](requestParams);
    },
    [SUGGESTION_TYPES.SUGGESTIONS_LAST_NAME](params) {
        const requestParams = {
            ...params,
            service: SERVICE_TYPE_LAST_NAME,
        };

        return this[SUGGESTION_TYPES.SUGGESTIONS](requestParams);
    },
    [SUGGESTION_TYPES.SUGGESTIONS_PATRONYMIC](params) {
        const requestParams = {
            ...params,
            service: SERVICE_TYPE_PATRONYMIC,
        };

        return this[SUGGESTION_TYPES.SUGGESTIONS](requestParams);
    },
    [SUGGESTION_TYPES.SUGGESTIONS_FULLNAME](params) {
        const requestParams = {
            ...params,
            service: SERVICE_TYPE_FIO_FULL,
        };

        return this[SUGGESTION_TYPES.SUGGESTIONS](requestParams);
    },
    [SUGGESTION_TYPES.SUGGESTIONS_AHUNTER_ADDRESS](params) {
        const requestParams = {
            ...params,
            service: SERVICE_TYPE_AHUNTER_ADDRESS,
        };

        return this[SUGGESTION_TYPES.SUGGESTIONS](requestParams);
    },
    [SUGGESTION_TYPES.SUGGESTIONS_DADATA_ADDRESS](params) {
        const requestParams = {
            ...params,
        };
        const queryParams = {
            service: SERVICE_TYPE_DADATA_ADDRESS,
        };

        return this[SUGGESTION_TYPES.SUGGESTIONS_POST](requestParams, queryParams);
    },
    [SUGGESTION_TYPES.SUGGESTIONS_EMAIL](params) {
        const requestParams = {
            ...params,
            service: SERVICE_TYPE_EMAIL,
        };

        return this[SUGGESTION_TYPES.SUGGESTIONS](requestParams);
    },
    [SUGGESTION_TYPES.SUGGESTIONS_PROFESSION](params) {
        const requestParams = {
            ...params,
            service: SERVICE_TYPE_PROFESSION,
        };

        return this[SUGGESTION_TYPES.SUGGESTIONS](requestParams);
    },
    [SUGGESTION_TYPES.SUGGESTIONS_DADATA_BANK](params) {
        const filtered = params.query.replace(/_/g, '');
        const requestParams = {
            ...params,
            query: filtered,
            service: SERVICE_TYPE_DADATA_BANK,
        };

        return this[SUGGESTION_TYPES.SUGGESTIONS](requestParams);
    },
    [SUGGESTION_TYPES.SUGGESTIONS_POST_CODE](params) {
        const requestParams = {
            ...params,
            service: SERVICE_TYPE_POSTCODE,
        };

        return this[SUGGESTION_TYPES.SUGGESTIONS](requestParams);
    },
    [SUGGESTION_TYPES.SUGGESTIONS_PASSPORT_ISSUED_NAME](params) {
        const requestParams = {
            ...params,
            service: SERVICE_TYPE_DADATA_FMS_ISSUED_NAME,
        };

        return this[SUGGESTION_TYPES.SUGGESTIONS](requestParams);
    },
};

export default suggestionsApiClient;
